import database_es from './database_es.json';

export default database_es;